import React from "react";
import Grid from "@visa/vds/grid";

const MCSGrid = (props) => {
    let className = "mcs-grid" + (props.className ? " " + props.className : "");
    return <Grid
        className={className}
        type={props.type}>
            {props.children}
        </Grid>
};

export default MCSGrid;
